import React from "react";

import { Box, useTheme, useMediaQuery } from "@mui/material";
import discordImg from "assets/images/discord-app.png";
import { DiscordFull } from "components/icons";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";

const Banner: React.FC = () => {
  const { colors } = useMUIThemeModeContext();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      borderRadius={"8px"}
      bgcolor={colors.deepSpaceBlueDark}
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}>
      <DiscordFull
        style={{
          width: isMobile ? 110 : 150,
          height: "auto",
          color: "white",
          marginLeft: theme.spacing(isMobile ? 1.5 : 3),
        }}
      />
      <img src={discordImg} alt={"discord app"} style={{ width: isMobile ? "130px" : "170px", borderRadius: "10px" }} />
    </Box>
  );
};

export default Banner;
